export const CHANNELS_FOCUS_KEY = 'FavoritesEditChannels';
export const CHANNELS_SELECTED_FOCUS_KEY = 'FavoritesEditChannelsSelected';

export const UNSELECTED_ITEM_FOCUS_KEY = 'UnselectedChannelFocusKey';
export const SELECTED_ITEM_FOCUS_KEY = 'SelectedChannelFocusKey';
